<div class="modal-dialog custom-modal-width"> <!-- Custom class for wider modal -->
  <div class="modal-content modal-box">
    <div class="modal-header d-flex justify-content-between align-items-start ">
      <h6 class="m-0">Add A Post</h6>
      <button type="button" class="close" (click)="onCancel()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
        <div class="container-fluid p-0">
            <div class="col-1 mt-2" style="display:table-cell !important;">
                <div class="user-avatar-container-top">
                    <img class="circular-image" [src]="'/img_profile/' + UserID + '/' + UserImg" alt="" height="50px" style="vertical-align:top;">
                </div>
            </div>

            <div class="col-11 ">
                <app-reply-submit (postEditedOrDeleted)="onPostSaved()"
                                  [Username]="Username"
                                  [UserID]="UserID"
                                  [OriginalPostID]="OriginalPostID"
                                  [ReplyPostID]="ReplyPostID"
                                  [PostUsername]="PostUsername"
                                  [pageType]="'postSubmitModal'">
                </app-reply-submit>
            </div>
        </div>
    </div>
    <div class="modal-footer no-border-top">
        <div class="col-7 text-info">
        </div>
        <div class="col-4 ">
              <!--<button type="button" class="btn btn-primary" (click)="submitPost()">Post</button>-->
              <!--<button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button>-->
        </div>
    </div>
  </div>
</div>
